import React from 'react';
import { Icon } from './icons.jsx';
// Impersonação Segura — modal, banner e gestão de sessões
const { useState, useEffect } = React;

const IMPERS_SESSIONS_MOCK = [
  { id: 'imp_88', start: 'Hoje, 11:08',    end: 'Hoje, 11:38',    actor: 'Pedro Chaves',   tenant: 'Dona Clara Doces',     user: 'renata@donaclara.com.br',    duration: '30 min',  status: 'encerrada', reason: 'Diagnóstico de suporte solicitado', ip: '177.142.12.8' },
  { id: 'imp_87', start: 'Ontem, 10:30',   end: 'Ontem, 10:55',   actor: 'Rafael Tavares', tenant: 'Oficina do Skate',     user: 'fabricio@oficinadoskate.com', duration: '25 min',  status: 'encerrada', reason: 'Verificar configuração de frete',   ip: '203.11.44.22' },
  { id: 'imp_86', start: '22 Mai, 14:00',  end: '22 Mai, 14:15',  actor: 'Ana Vargas',     tenant: 'Moda Clara',           user: 'suporte@modaclara.com.br',    duration: '15 min',  status: 'encerrada', reason: 'Investigar falha de provisionamento', ip: '177.142.12.8' },
  { id: 'imp_85', start: '21 Mai, 16:00',  end: null,             actor: 'Beatriz Lima',   tenant: 'Tech Store Brasil',    user: 'carlos@techstore.com.br',     duration: '—',       status: 'ativa',     reason: 'Verificar listagem de produtos',    ip: '201.55.33.18' },
  { id: 'imp_84', start: '20 Mai, 10:00',  end: '20 Mai, 10:45',  actor: 'Pedro Chaves',   tenant: 'Loja Exemplo Premium', user: 'ana@lojaexemplo.com.br',      duration: '45 min',  status: 'expirada',  reason: 'Onboarding assistido',              ip: '177.142.12.8' },
];

const SESSION_STATUS = {
  ativa:      { label: 'Ativa',      cls: 'danger'  },
  encerrada:  { label: 'Encerrada',  cls: 'neutral' },
  expirada:   { label: 'Expirada',   cls: 'warning' },
  revogada:   { label: 'Revogada',   cls: 'danger'  },
  bloqueada:  { label: 'Bloqueada',  cls: 'danger'  },
};

// Componente de modal de impersonação segura
const ImpersonationModal = ({ open, store, targetUser, onClose, onConfirm, logAction }) => {
  const [motivo,     setMotivo]     = useState('');
  const [duration,   setDuration]   = useState('30min');
  const [readOnly,   setReadOnly]   = useState(false);
  const [blockDestr, setBlockDestr] = useState(true);
  const [audited,    setAudited]    = useState(false);
  const [step,       setStep]       = useState('form'); // 'form' | 'active'
  const [sessionId,  setSessionId]  = useState('');
  const [token,      setToken]      = useState('');
  const [timeLeft,   setTimeLeft]   = useState(null);

  useEffect(() => {
    if (!open) { setStep('form'); setMotivo(''); setAudited(false); }
  }, [open]);

  useEffect(() => {
    if (step !== 'active') return;
    const MINS = { '15min': 15, '30min': 30, '1h': 60, 'custom': 30 };
    let secs = (MINS[duration] || 30) * 60;
    setTimeLeft(secs);
    const iv = setInterval(() => {
      secs--;
      setTimeLeft(secs);
      if (secs <= 0) { clearInterval(iv); }
    }, 1000);
    return () => clearInterval(iv);
  }, [step]);

  if (!open) return null;

  const canConfirm = motivo.trim().length >= 10 && audited;

  const handleStart = () => {
    const sid = `imp_${Date.now().toString().slice(-4)}`;
    const tok = `tz_imp_${'x'.repeat(6)}${'y'.repeat(16)}`;
    setSessionId(sid);
    setToken(tok);
    setStep('active');
    if (logAction) logAction({ acao: `Login como lojista iniciado · ${store?.name} · motivo: ${motivo}`, loja: store?.name, lojaId: store?.id, kind: 'info' });
    if (onConfirm) onConfirm({ sessionId: sid, store, motivo, duration, readOnly, blockDestr });
  };

  const handleEnd = () => {
    if (logAction) logAction({ acao: `Login como lojista encerrado · ${store?.name}`, loja: store?.name, lojaId: store?.id, kind: 'info' });
    onClose();
  };

  const fmtTime = (s) => {
    if (s === null) return '--:--';
    const m = Math.floor(s / 60), sec = s % 60;
    return `${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`;
  };

  return (
    <div onClick={step === 'form' ? onClose : undefined} style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,0.55)', backdropFilter: 'blur(4px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: 500, background: 'var(--bg-elevated)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', overflow: 'hidden', border: '1px solid var(--border)' }}>

        {/* Header */}
        <div style={{ padding: '18px 22px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <div style={{ width: 40, height: 40, borderRadius: 10, background: step === 'active' ? 'var(--danger-bg)' : 'var(--warning-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon name="impersonate" size={20} style={{ color: step === 'active' ? 'var(--danger)' : 'var(--warning)' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>
              {step === 'form' ? 'Iniciar impersonação segura' : 'Sessão de impersonação ativa'}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
              {step === 'active'
                ? <span style={{ color: 'var(--danger)', fontWeight: 600 }}>⚠ Você está acessando como o lojista · toda ação é auditada</span>
                : 'Esta ação é auditada obrigatoriamente. Informe o motivo.'}
            </div>
          </div>
          {step === 'form' && <button className="icon-action" onClick={onClose}><Icon name="x" size={16} /></button>}
        </div>

        <div style={{ padding: '16px 22px' }}>
          {step === 'form' && (
            <>
              {/* Tenant info */}
              <div style={{ padding: '12px 14px', background: 'var(--bg-subtle)', borderRadius: 10, marginBottom: 16, display: 'flex', gap: 14 }}>
                <div style={{ width: 40, height: 40, borderRadius: 8, background: 'var(--brand-navy)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, flexShrink: 0 }}>
                  {store?.name?.slice(0,2).toUpperCase() || 'LS'}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{store?.name || 'Loja Exemplo Premium'}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>{store?.domain || 'lojaexemplo.tezus.com.br'} · Plano {store?.plan?.name || 'Pro'}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 4 }}>Usuário alvo: <strong>{targetUser || store?.ownerEmail || 'ana@lojaexemplo.com.br'}</strong></div>
                </div>
              </div>

              {/* Duração */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 8 }}>Duração da sessão</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  {[['15min','15 min'], ['30min','30 min'], ['1h','1 hora'], ['custom','Personalizado']].map(([val, lbl]) => (
                    <button key={val} onClick={() => setDuration(val)} style={{ flex: 1, padding: '7px 0', border: '1.5px solid', borderRadius: 8, fontSize: 12, fontWeight: 500, cursor: 'pointer', background: duration === val ? 'var(--brand-navy)' : 'var(--bg-elevated)', color: duration === val ? 'white' : 'var(--text-secondary)', borderColor: duration === val ? 'var(--brand-navy)' : 'var(--border-strong)', transition: 'all 120ms' }}>
                      {lbl}
                    </button>
                  ))}
                </div>
              </div>

              {/* Permissões */}
              <div style={{ marginBottom: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={readOnly} onChange={e => setReadOnly(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 15, height: 15, flexShrink: 0 }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>Acesso somente leitura</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Bloqueia todas as ações de escrita na sessão</div>
                  </div>
                </label>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={blockDestr} onChange={e => setBlockDestr(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--brand-navy)', width: 15, height: 15, flexShrink: 0 }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500 }}>Bloquear ações destrutivas</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>Impede exclusões e alterações irreversíveis</div>
                  </div>
                </label>
              </div>

              {/* Motivo */}
              <div style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>
                  Motivo <span style={{ color: 'var(--danger)' }}>*</span>
                  <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 6 }}>(mínimo 10 caracteres)</span>
                </label>
                <textarea value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Ex: Cliente relatou erro na tela de pedidos, diagnóstico remoto necessário" style={{ width: '100%', height: 72, padding: '8px 12px', borderRadius: 8, border: `1.5px solid ${motivo.length > 0 && motivo.length < 10 ? 'var(--danger)' : 'var(--border-strong)'}`, background: 'var(--bg-elevated)', color: 'var(--text)', fontSize: 13, fontFamily: 'inherit', resize: 'none' }} />
                {motivo.length > 0 && motivo.length < 10 && (
                  <div style={{ fontSize: 11, color: 'var(--danger)', marginTop: 4 }}>Informe pelo menos 10 caracteres</div>
                )}
              </div>

              {/* Audit checkbox */}
              <div style={{ padding: '10px 12px', background: 'var(--warning-bg)', borderRadius: 8, marginBottom: 14 }}>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input type="checkbox" checked={audited} onChange={e => setAudited(e.target.checked)} style={{ marginTop: 2, accentColor: 'var(--warning)', width: 15, height: 15, flexShrink: 0 }} />
                  <span style={{ fontSize: 13, color: 'var(--warning)', fontWeight: 500, lineHeight: 1.4 }}>
                    Entendo que esta ação será auditada e registrada permanentemente com meu nome, IP e motivo informado.
                  </span>
                </label>
              </div>
            </>
          )}

          {step === 'active' && (
            <>
              {/* Active session status */}
              <div style={{ padding: '14px 16px', background: 'var(--danger-bg)', borderRadius: 10, marginBottom: 16, border: '1px solid color-mix(in srgb, var(--danger) 30%, transparent)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <div style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--danger)', boxShadow: '0 0 0 3px color-mix(in srgb, var(--danger) 30%, transparent)', animation: 'pulse 1.6s infinite', flexShrink: 0 }} />
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--danger)' }}>Sessão ativa · {store?.name}</span>
                  <span style={{ marginLeft: 'auto', fontFamily: 'JetBrains Mono, monospace', fontSize: 18, fontWeight: 700, color: 'var(--danger)' }}>{fmtTime(timeLeft)}</span>
                </div>
                <div style={{ fontSize: 12, color: 'var(--danger)', opacity: 0.8 }}>ID: <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>{sessionId}</code> · {readOnly && 'Somente leitura · '}{blockDestr && 'Destrutivas bloqueadas'}</div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>Link do dashboard</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input readOnly value={`https://app1.tezus.com.br/impersonate/${sessionId}/`} style={{ flex: 1, height: 36, padding: '0 12px', borderRadius: 8, border: '1px solid var(--border-strong)', background: 'var(--bg-subtle)', color: 'var(--text-secondary)', fontSize: 12, fontFamily: 'JetBrains Mono, monospace' }} />
                    <button className="btn sm" onClick={() => { navigator.clipboard?.writeText(`https://app1.tezus.com.br/impersonate/${sessionId}/`); }}>
                      <Icon name="copy" size={12} />Copiar
                    </button>
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>Token temporário (mascarado)</label>
                  <div style={{ padding: '8px 12px', background: 'var(--bg-subtle)', borderRadius: 8, fontFamily: 'JetBrains Mono, monospace', fontSize: 12, color: 'var(--text-muted)', letterSpacing: '0.05em' }}>
                    {token.slice(0, 12)}{'•'.repeat(16)}
                  </div>
                </div>
                <button className="btn primary" onClick={() => window.open('#', '_blank')} style={{ justifyContent: 'center' }}>
                  <Icon name="externalLink" size={14} />Abrir dashboard do tenant
                </button>
              </div>
            </>
          )}
        </div>

        <div style={{ padding: '12px 22px', background: 'var(--bg-subtle)', display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid var(--border)' }}>
          {step === 'form' ? (
            <>
              <button className="btn" onClick={onClose}>Cancelar</button>
              <button className="btn danger" disabled={!canConfirm} onClick={handleStart}>
                <Icon name="impersonate" size={14} />Iniciar impersonação
              </button>
            </>
          ) : (
            <button className="btn danger" onClick={handleEnd} style={{ width: '100%', justifyContent: 'center' }}>
              <Icon name="x" size={14} />Encerrar sessão agora
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Banner de impersonação avançado (substitui o simples)
const ActiveImpersonationBannerV2 = ({ store, sessionId, readOnly, onExit }) => (
  <div style={{ background: 'var(--danger)', padding: '10px 28px', display: 'flex', alignItems: 'center', gap: 14, fontSize: 13, color: 'white' }}>
    <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#ffc857', boxShadow: '0 0 0 3px rgba(255,200,87,0.4)', animation: 'pulse 1.6s infinite', flexShrink: 0 }} />
    <Icon name="impersonate" size={16} style={{ flexShrink: 0 }} />
    <span>Você está impersonando <strong>{store?.ownerEmail || 'lojista'}</strong> na loja <strong>{store?.name}</strong></span>
    {readOnly && <span style={{ background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>SOMENTE LEITURA</span>}
    <span style={{ fontSize: 11, opacity: 0.7, marginLeft: 4 }}>ID: <code style={{ fontFamily: 'JetBrains Mono, monospace' }}>{sessionId || 'imp_—'}</code></span>
    <button onClick={onExit} style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: 'white', height: 28, padding: '0 14px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
      Encerrar impersonação
    </button>
  </div>
);

// Página de sessões de impersonação
const ImpersonationSessionsPage = ({ onToast, logAction }) => {
  const [sessions] = useState(IMPERS_SESSIONS_MOCK);

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h3 style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 600 }}>Sessões de impersonação</h3>
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>Histórico completo de acessos como lojista</p>
      </div>
      <div className="table-wrap">
        <div className="table-toolbar">
          <div className="filter-chips">
            {['Todas', 'Ativas', 'Encerradas', 'Expiradas'].map(f => (
              <button key={f} className={`filter-chip${f === 'Todas' ? ' active' : ''}`}>{f}</button>
            ))}
          </div>
          <span style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--text-muted)' }}>{sessions.length} sessões</span>
        </div>
        <table className="data">
          <thead>
            <tr>
              <th>ID</th><th>Iniciada em</th><th>Encerrada em</th><th>Ator</th>
              <th>Tenant</th><th>Usuário impersonado</th><th>Duração</th><th>Status</th><th>Motivo</th>
              <th style={{ textAlign: 'right' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {sessions.map(s => {
              const sc = SESSION_STATUS[s.status] || SESSION_STATUS.encerrada;
              return (
                <tr key={s.id}>
                  <td><code style={{ fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-muted)' }}>{s.id}</code></td>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{s.start}</td>
                  <td style={{ fontSize: 12, color: 'var(--text-muted)' }}>{s.end || <span style={{ color: 'var(--danger)', fontWeight: 600 }}>Em andamento</span>}</td>
                  <td style={{ fontWeight: 500, fontSize: 13 }}>{s.actor}</td>
                  <td style={{ fontSize: 13 }}>{s.tenant}</td>
                  <td style={{ fontSize: 12, fontFamily: 'JetBrains Mono, monospace', color: 'var(--text-secondary)' }}>{s.user}</td>
                  <td style={{ fontWeight: 500 }}>{s.duration}</td>
                  <td><span className={`badge ${sc.cls}`}><span className="dot" />{sc.label}</span></td>
                  <td style={{ fontSize: 12, color: 'var(--text-secondary)', maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.reason}</td>
                  <td>
                    <div className="row-actions">
                      {s.status === 'ativa' && (
                        <button className="icon-action danger" title="Revogar sessão" onClick={() => onToast && onToast(`Sessão ${s.id} revogada`)}><Icon name="x" size={13} /></button>
                      )}
                      <button className="icon-action" title="Ver auditoria"><Icon name="audit" size={13} /></button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export {
  ActiveImpersonationBannerV2,
  ImpersonationModal,
  ImpersonationSessionsPage,
};
